<template>
  <div>
    <div class="app-toolbar1">
      <el-input size="small" placeholder="请输入表单名称" v-model="query.keyword" clearable style="width:320px">
        <el-button slot="append" size="small" icon="el-icon-search" @click="load(1)">查询</el-button>
      </el-input>
      <el-button size="small" icon="el-icon-plus" @click="toConfigTable()" type="primary">新建</el-button>
    </div>
    <el-table :data="forms" :stripe="true" size="mini" v-loading="loading">
      <el-table-column prop="dynamicFormId" label="ID" width="55"></el-table-column>
      <el-table-column prop="name" label="名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="acType" label="访问控制类型" width="94px">
        <template slot-scope="scope">
          <span v-if="scope.row.acType === acType.key" v-for="acType in acTypes" :key="acType.key">{{acType.label}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tableName" label="表名" width="180"></el-table-column>
      <el-table-column prop="idColumnName" label="ID列" width="160"></el-table-column>
      <el-table-column prop="accountColumnName" label="账户列" width="100"></el-table-column>
      <el-table-column prop="desc" label="描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="135"></el-table-column>
      <el-table-column prop="updateTime" label="最后更新时间" width="135"></el-table-column>
      <el-table-column fixed="right" label="操作" width="240">
        <template slot-scope="scope">
          <el-button @click="toConfigTable(null, scope.row.dynamicFormId)" type="primary" size="small">克隆新建</el-button>
          <el-button @click="toConfigTable(scope.row, null)" type="primary" size="small">配置</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="query.total > 0" :page-size="query.limit" :pager-count="11" layout="total, prev, pager, next" :total="query.total" :background="true" @current-change="load" class="app-pagination"></el-pagination>

    <form-table-config-dialog ref="tableConfigDialog" @save="toConfigForm"></form-table-config-dialog>
    <form-config-dialog :endpoint="endpoint" :uiId="uiId" :dfTablecolumns="dfTablecolumns" ref="configDialog" @save="load(query.page)"></form-config-dialog>
  </div>
</template>

<script>
import { calcPage } from '@/util'
import { acTypes } from '@/config'
import FormTableConfigDialog from './FormTableConfigDialog'
import FormConfigDialog from './FormConfigDialog'

export default {
  name: 'form-manage',
  components: {
    FormTableConfigDialog,
    FormConfigDialog
  },
  props: {
    uiId: { type: Number, required: true },
    endpoint: { type: String, required: true }
  },
  data () {
    return {
      acTypes: acTypes,
      loading: false,
      forms: [],
      query: {
        page: 1,
        limit: 10,
        total: 0,
        keyword: ''
      },
      dynamicFormOfUpdate: null,
      dynamicFormIdOfClone: null,
      dfTablecolumns: []
    }
  },
  created () {
    this.load(1)
  },
  watch: {
    uiId () {
      this.load(1)
    }
  },
  methods: {
    load (page) {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgDynamicForms?uiId=${this.uiId}&page=${page}&limit=${this.query.limit}&keyword=${this.query.keyword}&excludeNoneTable=NO`
      }).then((res) => {
        let pageData = res.data.data
        this.forms = pageData.data
        this.query.page = pageData.page
        this.query.total = pageData.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    toConfigTable (dynamicFormOfUpdate, dynamicFormIdOfClone) {
      this.dynamicFormOfUpdate = dynamicFormOfUpdate
      this.dynamicFormIdOfClone = dynamicFormIdOfClone
      this.$refs.tableConfigDialog.open(dynamicFormOfUpdate)
    },
    toConfigForm (data) {
      this.dfTablecolumns = data.columns

      let dynamicForm = this.dynamicFormOfUpdate || {}
      this.$refs.configDialog.open({
        dynamicFormId: dynamicForm.dynamicFormId,
        name: dynamicForm.name,
        acType: dynamicForm.acType,
        desc: dynamicForm.desc,
        tableName: data.tableName,
        idColumnName: data.idColumnName,
        accountColumnName: data.accountColumnName,
        createTimeColumnName: data.createTimeColumnName,
        updateTimeColumnName: data.updateTimeColumnName,
        creatorColumnName: data.creatorColumnName,
        updatorColumnName: data.updatorColumnName
      }, this.dynamicFormIdOfClone)
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该表单吗?', data: row, scope: this, callback: this.doDelete })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgDynamicForms/${data.dynamicFormId}`
        }).then(() => {
          this.$message.success('删除成功')
          this.load(calcPage(this.query))
        })
      }
    }
  }
}
</script>
